module.exports = __webpack_public_path__ + "static/media/orchard.54270361.png";